// extracted by mini-css-extract-plugin
export default {"circle":"Image_circle__5iBSG","square":"Image_square__akSM7"};